/* eslint-disable @typescript-eslint/ban-ts-comment */
import parsePaymentValue from "./parsePaymentValue";
import {
  ProductSeparatedWithTypes,
  ProductToSeparateWithPaymentSettings,
} from "./types";

const getProductsPaymentSettingsDataWithFormattedValue = (
  productsPaymentSettingsData:
    | (
        | ProductSeparatedWithTypes
        | ProductSeparatedWithTypes["payment_settings"]
      )[]
    | ProductToSeparateWithPaymentSettings[]
) =>
  productsPaymentSettingsData.map((item) =>
    // @ts-ignore
    item?.value ? { ...item, value: parsePaymentValue(item.value) } : item
  );

export default getProductsPaymentSettingsDataWithFormattedValue;
